/**
 * `/products/new` — the product add form (build item 13, docs/plan.md →
 * Screens, "Product add / edit"). hideShellChrome per the design's
 * `isProductEdit` branch — `ProductFormView` renders its own back bar and
 * sticky Cancel/Save footer, full-bleed.
 *
 * No product exists yet, so `ProductFormView` gets `product: null` — see that
 * file's header comment for how it handles the Photos section before a
 * product id exists.
 */
import { createFileRoute } from '@tanstack/react-router';

import { ProductFormView } from '@/components/product-mgmt/product-form-view';

export const Route = createFileRoute('/_app/products/new')({
  staticData: { hideShellChrome: true },
  component: () => <ProductFormView mode="create" product={null} />
});
